<script setup>
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>

<template>
  <section class="rounded-lais border border-lais-border-soft bg-white p-5">
    <h2 class="font-redHatDisplay text-lg font-semibold text-lais-text">
      {{ t('SALES.REVIEW.RETURN_INFO.TITLE') }}
    </h2>
    <p class="mt-2 text-sm text-lais-text-body">
      {{ t('SALES.REVIEW.RETURN_INFO.SUBTITLE') }}
    </p>
    <div
      role="note"
      class="mt-4 flex gap-3 rounded-lais bg-lais-primary-50 p-4 text-sm text-lais-text-body"
    >
      <span
        class="i-lucide-circle-alert mt-0.5 size-5 shrink-0 text-lais-primary"
        aria-hidden="true"
      />
      <p>
        {{ t('SALES.REVIEW.RETURN_INFO.ALERT_PREFIX') }}
        <strong>{{ t('SALES.REVIEW.RETURN_INFO.ALERT_STATUS') }}</strong>
      </p>
    </div>
    <p class="mt-4 text-sm font-semibold text-lais-text">
      {{ t('SALES.REVIEW.RETURN_INFO.PROMPT') }}
    </p>
  </section>
</template>
